var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4246_643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.001 0C23.2268 0 30.001 6.77419 30.001 15C30.001 23.2863 23.2268 30 15.001 30C6.71469 30 0.000976562 23.2863 0.000976562 15C0.000976562 6.77419 6.71469 0 15.001 0ZM15.001 27.0968C21.6542 27.0968 27.0977 21.7137 27.0977 15C27.0977 8.34678 21.6542 2.90323 15.001 2.90323C8.28727 2.90323 2.9042 8.34678 2.9042 15C2.9042 21.7137 8.28727 27.0968 15.001 27.0968ZM15.001 6.65323C16.3921 6.65323 17.5413 7.80242 17.5413 9.19355C17.5413 10.6452 16.3921 11.7339 15.001 11.7339C13.5494 11.7339 12.4607 10.6452 12.4607 9.19355C12.4607 7.80242 13.5494 6.65323 15.001 6.65323ZM18.3881 22.0161C18.3881 22.4395 18.0252 22.7419 17.6623 22.7419H12.3397C11.9163 22.7419 11.6139 22.4395 11.6139 22.0161V20.5645C11.6139 20.2016 11.9163 19.8387 12.3397 19.8387H13.0655V15.9677H12.3397C11.9163 15.9677 11.6139 15.6653 11.6139 15.2419V13.7903C11.6139 13.4274 11.9163 13.0645 12.3397 13.0645H16.2107C16.5736 13.0645 16.9365 13.4274 16.9365 13.7903V19.8387H17.6623C18.0252 19.8387 18.3881 20.2016 18.3881 20.5645V22.0161Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4246_643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.447973afab76fdc2b6d42461cc95ce5b.svg";
export { ForwardRef as ReactComponent };